import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateClientContactActions } from "store/ducks/settings/client-contact";

export function* updateClientContactRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/client-contact/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateClientContactActions.success(data));
    notify("success", "Contato atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateClientContactActions.failure(errorMessage));
  }
}
